/**
 * Avatar — 사용자 프로필 아바타
 *
 * 이미지가 있으면 원형 이미지를 표시하고, 없거나 로드 실패 시 이름 첫 글자를 표시한다.
 */

import { useState } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Avatar.module.css'

function getColorFromName(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 45%, 62%)`
}

interface AvatarProps {
  src?: string
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

export function Avatar({ src, name, size = 'md', className }: AvatarProps) {
  const [imgError, setImgError] = useState(false)
  const showImage = src && !imgError
  const initial = name.charAt(0)
  const bgColor = getColorFromName(name)

  return (
    <div
      className={cn(styles.root, styles[size], className)}
      style={!showImage ? { backgroundColor: bgColor } : undefined}
      aria-label={name}
    >
      {showImage ? (
        <img
          src={src}
          alt={name}
          className={styles.image}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className={styles.initials}>{initial}</span>
      )}
    </div>
  )
}
